module.exports = __webpack_public_path__ + "img/grading_success.3924d27d.png";